var _style, _path, _polygon, _polygon2, _polygon3, _polygon4, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAshley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 420.2 72.9",
    style: {
      enableBackground: "new 0 0 420.2 72.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3D3935;}\n\t.st1{fill:#F88D2A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185,36.6c-8.5-0.7-14.5-1.4-14.5-4.9c0-0.9,0.4-1.7,1-2.3c2.2-2.2,7.6-3,11.9-2.9c6.6,0,11.8,1.8,15.6,5.1 l0.4,0.4l5-5.4l-0.5-0.4c-5-4.2-12.4-6.6-20.7-6.6c-12.4,0-20.7,5-20.7,12.6c0,9,12.2,11,21.4,11.8c9.6,0.8,14.1,1.8,14.1,5.3 c0,3.7-4.7,5.8-12.9,5.8c-7.8,0-13.9-2.1-19-6.7l-0.4-0.4l-4.9,5.6l0.4,0.4c6.1,5.3,14.3,8,23.6,8c13,0,21.1-5.1,21.1-13.2 C206.1,39.5,196,37.5,185,36.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "248.9,36.9 220.6,36.9 220.6,20.7 212.8,20.7 212.8,60.8 220.6,60.8 220.6,44 248.9,44 248.9,60.8  256.7,60.8 256.7,20.7 248.9,20.7 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "272.4,20.7 264.5,20.7 264.5,60.8 301.1,60.8 301.1,53.7 272.4,53.7 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "315.1,43.9 341.7,43.9 341.7,36.9 315.1,36.9 315.1,27.7 346.7,27.7 346.7,20.7 307.3,20.7 307.3,60.8  347.2,60.8 347.2,53.8 315.1,53.8 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "374.6,40 360,20.7 350.9,20.7 370.6,46.9 370.6,60.8 378.5,60.8 378.5,46.9 398.2,20.7 389,20.7 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.1,11.6L96.5,60.8h9.1l6.3-11.9h31.6l6.3,11.9h9.2l-26.6-49.2H123.1z M115.7,41.7l12-22.8l12,22.8 L115.7,41.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.2,34.2L46.2,8c0,0-0.1,0-0.1,0c0,0,0,0,0,0l-26,26.2l0,0v26.4c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0h52 c0,0,0.1,0,0.1-0.1L72.2,34.2C72.2,34.3,72.2,34.3,72.2,34.2z M64.8,52.7c0,0.5-0.1,0.6-0.6,0.6H27.9c-0.5,0-0.5-0.4-0.5-0.6V38.1 c-0.1-0.5,0.1-1,0.5-1.3l0,0c0.5-0.5,17.4-17.5,17.5-17.7c0.2-0.2,0.5-0.4,0.7-0.4c0.2,0,0.3,0.1,0.6,0.4L64.5,37 c0.2,0.2,0.4,0.5,0.3,0.8V52.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAshley);
export default __webpack_public_path__ + "static/media/Ashley.4574255dcdc14f8c6e1010d1ffec2d15.svg";
export { ForwardRef as ReactComponent };